var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTooltip)?_c('v-tooltip',{attrs:{"bottom":"","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"primary"}},on),[_vm._v(" mdi-information-outline ")])]}}],null,false,1816130901)},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("activate_tooltip", { model: _vm.model }))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }